module.exports = __webpack_public_path__ + "img/ceo_way_cho_03.446bd931.png";